/*
 * Inline header search (snippets/header-search-inline.liquid).
 *
 * 1. Live suggestions: typing fetches the ac-search-suggest section through
 *    Shopify's predictive search (/search/suggest), so results follow the
 *    Search & Discovery app's synonyms and boosts. Debounced 200ms, earlier
 *    requests are aborted, results are cached per query. The panel is fixed-
 *    positioned from the field's box so the header's overflow never clips it.
 *
 * 2. Typed placeholder: innovist.com types its placeholder out letter by
 *    letter (100ms per letter), holds it 1s, erases it (50ms per letter),
 *    waits 1s and moves to the next phrase. Same timings here; skipped for
 *    users who prefer reduced motion. The letters go into the `data-typed`
 *    attribute of the .ac-search__ghost overlay (rendered by CSS
 *    `content: attr(data-typed)`), not into the input's placeholder and not
 *    as a text node: Horizon's stylesheet anchors `:has()` rules on <html>
 *    and <body>, so in Chrome any node insertion anywhere in the document
 *    re-resolves styles for the whole header subtree (~30ms per letter). A
 *    data-attribute write that no selector reads costs well under a ms.
 */
(function () {
  if (window.acSearchSuggest) return;
  window.acSearchSuggest = true;

  function setup(form) {
    var root = (form.getAttribute('data-root') || '/').replace(/\/$/, '');
    var input = form.querySelector('.ac-search__input');
    var panel = form.querySelector('.ac-suggest');
    if (!input || !panel) return;
    var live = panel.querySelector('[data-suggest-live]');
    var popular = panel.querySelector('.ac-suggest__popular');
    var cache = {};
    var timer, ctrl, active = -1;

    function place() {
      var r = input.getBoundingClientRect();
      var mobile = window.innerWidth <= 768;
      var width = mobile ? window.innerWidth - 24 : Math.max(r.width, 460);
      var left = mobile ? 12 : Math.min(r.left, window.innerWidth - width - 16);
      panel.style.top = r.bottom + 8 + 'px';
      panel.style.left = left + 'px';
      panel.style.width = width + 'px';
      panel.style.maxHeight = window.innerHeight - r.bottom - 24 + 'px';
    }
    function open() {
      if (!panel.hidden) return;
      place();
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }
    function close() {
      if (panel.hidden) return;
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      active = -1;
    }
    function items() {
      return [].slice.call(panel.querySelectorAll('[data-suggest-item]')).filter(function (el) {
        return el.offsetParent !== null;
      });
    }
    function highlight(i) {
      var list = items();
      list.forEach(function (el) { el.classList.remove('is-active'); });
      if (!list.length) { active = -1; return; }
      active = (i + list.length) % list.length;
      list[active].classList.add('is-active');
      list[active].scrollIntoView({ block: 'nearest' });
    }
    function show(html) {
      live.innerHTML = html;
      popular.hidden = true;
      active = -1;
      open();
    }
    function query() {
      var q = input.value.trim();
      if (ctrl) ctrl.abort();
      if (!q) { live.innerHTML = ''; popular.hidden = false; return; }
      if (cache[q]) { show(cache[q]); return; }
      ctrl = new AbortController();
      var url = root + '/search/suggest?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,query,article&resources[limit]=6&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=last&section_id=ac-search-suggest';
      fetch(url, { signal: ctrl.signal })
        .then(function (res) { return res.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var inner = doc.querySelector('[data-suggest-results]');
          if (!inner) return;
          cache[q] = inner.outerHTML;
          if (input.value.trim() === q) show(cache[q]);
        })
        .catch(function () {});
    }

    input.addEventListener('focus', function () {
      if (!input.value.trim()) { live.innerHTML = ''; popular.hidden = false; }
      open();
    });
    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(query, 200);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); open(); highlight(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); highlight(active - 1); }
      else if (e.key === 'Escape') { close(); }
      else if (e.key === 'Enter' && active > -1) {
        var el = items()[active];
        if (el) { e.preventDefault(); window.location.href = el.href; }
      }
    });
    document.addEventListener('pointerdown', function (e) {
      if (!form.contains(e.target)) close();
    });
    form.addEventListener('focusout', function (e) {
      if (e.relatedTarget && !form.contains(e.relatedTarget)) close();
    });
    window.addEventListener('resize', function () { if (!panel.hidden) place(); });
    window.addEventListener('scroll', function () { if (!panel.hidden) place(); }, { passive: true, capture: true });
  }

  function init() { document.querySelectorAll('form.ac-search').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

(function () {
  if (window.invSearchTyping) return;
  window.invSearchTyping = true;
  function start(input) {
    if (input.dataset.invTypingOn) return;
    var ghost = input.parentNode.querySelector('.ac-search__ghost');
    if (!ghost) return;
    input.dataset.invTypingOn = '1';
    var phrases = input.dataset.invTyping.split('|');
    var index = 0;
    var text = '';
    input.setAttribute('placeholder', '');
    function sync() {
      ghost.classList.toggle('ac-search__ghost--hidden', input.value.length > 0);
    }
    input.addEventListener('input', sync);
    sync();
    function type() {
      var phrase = phrases[index], i = 0;
      var t = setInterval(function () {
        if (i === phrase.length) { clearInterval(t); setTimeout(erase, 1000); return; }
        text += phrase.charAt(i++);
        ghost.setAttribute('data-typed', text);
      }, 100);
    }
    function erase() {
      var t = setInterval(function () {
        if (!text.length) { clearInterval(t); index = (index + 1) % phrases.length; setTimeout(type, 1000); return; }
        text = text.slice(0, -1);
        ghost.setAttribute('data-typed', text);
      }, 50);
    }
    type();
  }
  function init() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('input[data-inv-typing]').forEach(start);
  }
  if (document.readyState === 'complete') init(); else window.addEventListener('load', init);
})();
